import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {CreditSearchParams} from '../../credit-search-params';
import {Credit} from '../../credit';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-credit-list',
  templateUrl: './credit-list.component.html',
  styleUrls: []
})
export class CreditListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new CreditSearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/credit', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: Credit) {
    this.router.navigateByUrl(`/credit/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/credit/create']);
  }
}
